import React from 'react';
import QuestionType, {
  getQuestionTypeText,
} from '@ax2/common/model/QuestionType';
import Dropdown from '@ax2/common/components/Dropdown';

export interface QuestionTypeDropdownData {
  value: QuestionType;
  disabled?: boolean;
  onChange?: (s: QuestionType) => void;
}

export const QuestionTypeDropdown: React.FC<
  QuestionTypeDropdownData
> = props => {
  const allOptions = Object.keys(QuestionType).map(
    key => QuestionType[key as QuestionType]
  );
  const options = allOptions.map(option => ({
    title: getQuestionTypeText(option),
    value: option,
  }));
  return <Dropdown options={options} {...props} />;
};
